import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { browserHistory } from "react-router";
import { Button, Row, Col, Panel, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import API from "../base/API";
import moment from "moment";
import Auth from "../auth/Auth";
import { translate } from "../base/Translation";

let DatePicker = require("react-bootstrap-date-picker");

export default class VehicleEdit extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_vehicle: "/vehicle/save/:vehicle",
			get_vehicle: "/vehicle/fetch/:vehicle",
			get_clients: "/user/fetch/by/role/:role",
			get_brands: "/brand/fetch/all"
		});

		this.state = {
			vehicle: null,
			clients: null,
			brands: null,
		};
	}

	fetchData() {

		this.api.request({
			route: "get_vehicle",
			params: { vehicle: this.props.params.vehicleID },
			success: (response) => {
				this.setState({ vehicle: response });
			}
		});

		this.api.request({
			route: "get_brands",
			success: (response) => {
				this.setState({ brands: response });
			}
		});
	}

	saveData() {
		this.api.request({
			route: "save_vehicle",
			params: { vehicle: this.props.params.vehicleID },
			data: this.state.vehicle,
			created: (response) => {
				browserHistory.push("/vehicles");
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	onVehicleChange(evt) {
		// Get vehicle from state
		let newVehicle = this.state.vehicle;

		let value = evt.target.value;

		if (evt.target.name === 'vin') {
			value = value.toUpperCase();
		}

		// Update it's value
		newVehicle[evt.target.name] = value;

		// Update vehicle in state
		this.setState({ vehicle: newVehicle });
	}

	onRegisteredChange(evt, date) {
		// Get vehicle from state
		let newVehicle = this.state.vehicle;

		newVehicle["registered"] = date;

		// Update vehicle in state
		this.setState({ vehicle: newVehicle });
	}

	onVehicleSave(evt) {
		this.saveData();
	}


	/*
	 *
	 * Render methods
	 *
	 */

	renderOptions(data) {
		let options = data.map(function (item) {
			return (
				<option value={item.id} key={item.id}>{typeof item.name !== "undefined" ? item.name : item.email}</option>
			)
		});

		return (options);
	}

	render() {

		if (this.state.vehicle === null || this.state.brands === null) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			)
		}

		const registered = moment(this.state.vehicle.registered, "DD.MM.YYYY").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");

		return (
			<Page>
				<PageHeader title={translate("Upraviť vozidlo")} />
				<PageBody>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Vozidlo")}>
								<FormGroup>
									<ControlLabel>{translate("EČV")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.ecv} name="ecv" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("VIN")}</ControlLabel>
									<FormControl value={this.state.vehicle.vin} name="vin" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Značka")}</ControlLabel>
									<select name="brand" defaultValue={this.state.vehicle.brand} onChange={this.onVehicleChange.bind(this)} className="form-control">
										<option value="0">{translate("Vyberte")}</option>
										{this.renderOptions(this.state.brands)}
									</select>
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Model")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.model} name="model" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Registrovaný")}</ControlLabel>
									<DatePicker dateFormat="DD.MM.YYYY" name="registered" value={registered}
										onChange={this.onRegisteredChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Počet kilometrov")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.number_of_kilometers} name="number_of_kilometers" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
							</Panel>
						</Col>
						<Col lg={6}>
							<Panel header={translate("Počet kilometrov")}>
								<FormGroup>
									<ControlLabel>{translate("Meno")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.driver_name} name="driver_name" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Priezvisko")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.driver_surname} name="driver_surname" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("E-Mail")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.driver_email} name="driver_email" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Mobil")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.driver_mobile} name="driver_mobile" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Obec")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.driver_city} name="driver_city" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Adresa")}</ControlLabel>
									<FormControl defaultValue={this.state.vehicle.driver_address} name="driver_address" onChange={this.onVehicleChange.bind(this)} />
								</FormGroup>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<Button bsStyle="success" onClick={this.onVehicleSave.bind(this)}>{translate("Uložiť")}</Button>
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<table className="table table-responsive table-hover">
								<thead>
									<tr>
										<th>{translate("Test")}</th>
										<th>{translate("Stav tachometra (km)")}</th>
									</tr>
								</thead>
								<tbody>
									{this.state.vehicle.tachometer_log.length > 0 ? this.state.vehicle.tachometer_log.map((item, index) => {
										return (
											<tr key={index}>
												<td>{item.test}</td>
												<td>{item.status}</td>
											</tr>
										)
									}) : <tr><td colSpan={2}>{translate("Žiadne záznamy neboli nájdené")}</td></tr>}
								</tbody>
							</table>
						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/vehicle/VehicleEdit.js